import { useEffect } from "react";

/**
 * Publishes an editor's flush as `window.debug.forceSave`, the hook e2e uses to force a save.
 *
 * Ownership is a stack: several editors can be mounted at once (a skill or fragment panel opens on
 * top of the article), so the effect restores the previous owner instead of clearing the global —
 * clearing it left the article without a flush once the panel closed.
 */
export const useForceSaveHandle = (flush: () => Promise<void>) => {
	useEffect(() => {
		if (typeof window === "undefined" || !window.debug) return;

		const previous = window.debug.forceSave;
		window.debug.forceSave = flush;

		return () => {
			if (window.debug?.forceSave === flush) window.debug.forceSave = previous ?? null;
		};
	}, [flush]);
};
